<template>
    <div>
        <navBar></navBar>
        <div class="main">
            <p class="title weight">用户协议</p>
            <p class="time">本协议发布时间：<span class="line">2024年 3 月 7 日</span></p>
            <p class="time">本协议更新时间：<span class="line">2024年 3 月 7 日</span></p>
            <div class="content">
                <p class="weight">1. 特别提示</p>
                <p class="weight">欢迎您使用“商业贸促会数据平台”网站及相关服务!</p>
                <p>1.1.
                    “商业贸促会数据平台”网站及相关服务，系指中国国际贸易促进委员会商业行业委员会(以下简称我会)及其关联公司合法拥有并运营的、标注名称为“商业贸促会数据平台”的网站向您提供的产品与服务，包括但不限于报名信息获取、发布信息、互动交流、搜索查询等核心功能及其他功能。《商业贸促会数据平台用户协议》(以下称“本协议”)是您与我会就您注册、登录、使用(以下统称“使用”“商业贸促会数据平台”网站，并获得“商业贸促会数据平台”网站提供的相关服务所订立的协议)。
                </p>
                <p>1.2.为了更好地为您提供服务，<span
                        class="weight">请您在开始使用“商业贸促会数据平台”网站及相关服务之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。</span>
                </p>
                <p>1.3.<span class="weight">如您未满18周岁，请您在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用“商业贸促会数据平台”网站及相关服务。</span>
                </p>
                <p>1.4.如您不同意本协议，这将导致我会无法为您提供完整的服务，您也可以选择停止使用。如您自主选择同意或使用“商业贸促会数据平台”网站及相关服务，则视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与“商业贸促会数据平台”网站及相关服务相关的协议和规则(包括但不限于《商业贸促会数据平台隐私政策》)的约束。
                </p>
                <p>1.5.我会有权依“商业贸促会数据平台”网站及相关服务或运营的需要单方决定，安排或指定其关联方、控制我会、继承我会或我会认可的第三方我会继续运营“商业贸促会数据平台”网站。并且，就本协议项下涉及的某些服务，可能会由我会的关联方、控制我会、继承我会或我会认可的第三方我会向您提供。您知晓并同意接受相关服务内容，即视为接受相关权利义务关系亦受本协议约束。
                </p>
                <p>1.6.如对本协议内容有任何疑问、意见或建议，您可通过登录“商业贸促会数据平台”客户端内与我会联系。</p>
                <p class="weight">
                    本《用户协议》将帮助您了解以下内容：<br />
                    （1）协议范围<br />
                    （2）用户账号规则<br />
                    （3）平台服务内容<br />
                    （4）用户行为规范<br />
                    （5）违约责任<br />
                    （6）免责声明<br />
                    （7）知识产权<br />
                    （8）第三方责任<br />
                    （9）服务的变更、中断和终止<br />
                    （10）帐号注销<br />
                    （11）未成年人使用条款<br />
                    （12）通知<br />
                    （13）联系方式<br />
                </p>
            </div>
            <div class="content">
                <p class="weight">2. 协议范围</p>
                <p>2.1. 签约主体</p>
                <p>2.1.1. 本协议由您与我方平台经营者共同缔结，本协议对您与我方平台经营者均具有合同效力。</p>
                <p>2.1.2. 我方平台经营者是指经营我方平台的各法律主体，本协议项下，<span
                        class="weight">我方平台经营者可能根据我方平台的业务调整而发生变更，变更后的我方平台经营者与您共同履行本协议并向您提供服务，我方平台经营者的变更不会影响您本协议项下的权益。我方平台经营者还有可能因为提供新的我方平台服务而新增，如您使用新增的我方平台服务的，视为您同意新增的我方平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。</span>
                </p>
                <p>2.2. 补充协议</p>
                <p>2.2.1.
                    由于行业高速发展，您与我方签署的本协议列明的条款并不能完整罗列并覆盖您与我方所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，我方平台《隐私权政策》、我方平台规则均为本协议的补充协议，与本协议不可分割且具有同等法律效力。<span
                        class="weight">
                        如您使用我方平台服务，视为您同意上述补充协议。
                    </span></p>
                <p>2.3. 用户协议变更</p>
                <p>2.3.1.<span
                        class="weight">我方平台可在我方平台更新用户协议、隐私权政策及相关平台规则（统称“用户协议”，届时协议更新会通过系统提示、信息推送或您在我方平台留下的联系方式通知您注意。用户协议变更后，如您继续使用我方平台服务，即意味着您同意接受我方更新后的用户协议。如您不同意变更后的用户协议，请您停止使用我方平台产品和服务。
                    </span></p>
            </div>
            <div class="content">
                <p class="weight">
                    3. 用户账号规则
                </p>
                <p>3.1.“商业贸促会数据平台”网站及相关服务为您提供了注册通道，您有权选择合法的字符组合作为自己的帐号，并自行设置符合安全要求的密码。用户设置的帐号、密码是用户用以登录并以注册用户身份使用“商业贸促会数据平台”网站及相关服务的凭证。
                </p>
                <p>3.2.您理解并承诺，您所设置的帐号不得违反国家法律法规及“商业贸促会数据平台”的相关规则，您的帐号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义(包括但不限于冒用他人姓名
                    名称、字号、头像等或采取其他足以让人引起混淆的方式)开设帐号，不得恶意注册“商业贸促会数据平台”帐号(包括但不限于频繁注册、批量注册帐号等行为)。您在帐号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。我会有权对您提交的注册信息进行审核。
                </p>
                <p>3.3.您在“商业贸促会数据平台”中的注册账号仅限于您本人使用，未经我会书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该帐号。如果我会发现或者有合理理由认为使用者并非帐号初始注册人，为保障帐号安全，我会有权立即暂停或终止向该注册帐号提供服务，并有权永久禁用该帐号。
                </p>
                <p>3.4.您有责任维护个人帐号、密码的安全性与保密性，并对您以注册帐号名义所从事的活动承担全部法律责任，包括但不限于您在“商业贸促会数据平台’网站及相关服务上进行的任何数据修改等操作行为可能引起的一切法律责任。由该等活动所导致的任何损失或损害由用户承担，我会不承担任何责任。您应高度重视对账号与密码的保密，在任何情况下不向他人透露帐号及密码。若发现他人未经许可使用您的帐号或发生其他任何安全漏洞问题时，您应当立即通知我会。
                </p>
                <p>3.5.如您丢失帐号或遗忘密码，可遵照我会的申诉途径及时申诉请求找回帐号或密码。您理解并认可，密码找回机制仅需要识别申诉单上所填资料与系统记录资料具有一致性，而无法识别申诉人是否系帐号真正有权使用者。<span
                        class="weight">
                        我会特别提醒您应保管好您的账户和密码。当您使用完后，应安全退出。因您保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，您应自行承担相应责任。
                    </span></p>
                <p>3.6.在注册、使用和管理帐号时，您应保证注册帐号时填写的身份信息的真实性，请您在注册、管理帐号时使用真实、准确、合法、有效的相关身份证明材料及必要信息(包括您的姓名及电子邮件地址、联系电话、联系地址等)。<span
                        class="weight">依照国家法律法规的规定，为使用“商业贸促会数据平台”网站及相关服务的部分功能，您需要填写真实的身份信息，请您按照相关法律规定完成实名认证，并注意及时更新上述相关信息。若您提交的材料或提供的信息不准确、不真实、不规范、不合法或者我会有理由怀疑为错误、不实或不合法的资料，则我会有权拒绝为您提供相关服务，您可能无法使用“商业贸促会数据平台”网站及相关服务或在使用过程中部分功能受到限制。</span>
                </p>
                <p>3.7.本平台只接受手机号自行注册“商业贸促会数据平台”帐号，不可使用其他网站或平台用户帐号，以及实名注册的第三方网站或平台用户帐号。</p>
                <p>3.8.用户个人信息保护我会与您一同致力于您个人信息(即能够独立或与其他信息结合后识别您身份的信息)的保护。保护用户个人信息是我会的基本原则之一,在使用“商业贸促会数据平台”网站及相关服务的过程中，您可能需要提供您的个人信息(包括但不限于您的姓名、电话号码、工作单位、职务等),以便我会、服务和相应的技术支持。更多关于您个人信息保护的内容，请参看《“商业贸促会数据平台"隐私政策》。
                </p>
            </div>
            <div class="content">
                <p class="weight">
                    4. 平台服务内容
                </p>
                <p>4.1. 在您遵守本协议及相关法律法规的前提下，我方给予您一项个人的、不可转让及非排他性的许可，以使用我方平台服务。</p>
                <p>4.2. 我方平台向您提供包括但不限于以下服务：</p>
                <p>4.2.1. 网站，包括网站域名。</p>
                <p>4.3. <span class="weight">
                        我方平台服务，均仅限于您在我方平台使用，任何以恶意破解等非法手段将我方服务与我方平台分离的行为，均不属于本协议中约定的我方服务。由此引起的一切法律后果由行为人负责，我方将依法追究行为人的法律责任。
                    </span></p>
                <p>4.4. 您使用“商业贸促会数据平台”网站及相关服务，可以通过预装、我会已授权的第三方下载等方式获取“商业贸促会数据平台”客户端应用程序或访问商业贸促会数据平台相关网站。<span
                        class="weight">
                        若您并非从我会或经我会授权的第三方获取“商业贸促会数据平台”网站的，我会无法保证非官方版本的“商业贸促会数据平台”网站能够正常使用，您因此遭受的损失与我会无关。
                    </span></p>
                <p>4.5 为更好的提升用户体验及服务，我会将不定期提供商业贸促会数据平台”网站及相关服务的更新或改变(包括但不限于网站修改、升级、功能强化、开发新服务、网站替换等)。</p>
                <p>4.6 <span class="weight">
                        除非得到我会明示事先书面授权，您不得以任何形式对“商业贸促会数据平台”网站及相关服务进行包括但不限于改编、复制、传播、垂直搜索、镜像或交易等未经授权的访问或使用。
                    </span></p>
                <p>4.7
                    您理解，您使用“商业贸促会数据平台”网站及相关服务需自行准备与网站及相关服务有关的终端设备(如电脑、手机等装置)，您在您终端设备中打开“商业贸促会数据平台”网站或访问“商业贸促会数据平台”相关网站，即视为您使用商业贸促会数据平台”网站及相关服务。为充分实现“商业贸促会数据平台”的全部功能，您可能需要将您的终端设备联网，您理解您应自行承担所需要的费用(如流量费、上网费等)。
                </p>
                <p>4.8如您发现“商业贸促会数据平台”网站内存在任何侵犯您权利的内容，您可参考《“商业贸促会数据平台”隐私政策》-联系我们，投诉途径通知我会，并提供您有相关权利的证据，我会将会依据相关法律规定及时处理您的投诉。
                </p>
            </div>
            <div class="content">
                <p class="weight">
                    5. 用户行为规范
                </p>
                <p>5.1. 用户行为要求您应对您使用“商业贸促会数据平台”网站及相关服务的行为负责，除非法律允许或者经我会事先书面许可，您使用“商业贸促会数据平台”网站及相关服务不得具有下列行为:</p>
                <p>5.2. 使用未经我会授权或许可的任何插件、外挂、系统或第三方工具对“商业贸促会数据平台”网站及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。</p>
                <p>5.3. 利用或针对“商业贸促会数据平台”网站及相关服务进行任何危害计算机网络安全的行为，包括但不限于:<br />
                    (1)非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动;<br />
                    (2)提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具;<br />
                    (3)明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助;<br />
                    (4)使用未经许可的数据或进入未经许可的服务器/帐号<br />
                    (5)未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息;<br />
                    (6)未经许可，企图探查、扫描、测试“商业贸促会数据平台”系统或网络的弱点或其它实施破坏网络安全的行为;<br />
                    (7)企图干涉、破坏“商业贸促会数据平台”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为;<br />
                    (8)伪造TCP/IP数据包名称或部分名称;<br />
                    (9)对“商业贸促会数据平台”网站及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现“商业贸促会数据平台”网站及相关服务的源代码<br />
                    (10)恶意注册“商业贸促会数据平台”帐号，包括但不限于频繁、批量注册帐号;<br />
                    (11)违反法律法规、本协议、我会的相关规则及侵犯他人合法权益的其他行为。<br />
                </p>
                <p>5.4. 如果我会有理由认为您的行为违反或可能违反上述约定的，我会可独立进行判断并处理，且在任何时候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。</p>
                <p>5.5. 信息内容展示及规范</p>
                <p>5.5.1.您按规定完成实名认证后，可以以注册帐号登录“商业贸促会数据平台”进行报名操作等。</p>
                <p>5.5.2.您制作、发布、传播的信息(包括但不限于上传至“商业贸促会数据平台”平台的未公开的头像)应自觉遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等“七条底线”要求，否则我会有权立即采取相应处理措施。包括但不限干资讯、资料、文字、网站、音乐、照片、图形、信息或其他资料等，您同意并承诺不制作、复制、发布、传播下列信息:
                </p>
                <p>(1)反对宪法确定的基本原则的;<br />
                    (2)危害国家安全，泄露国家秘密的;<br />
                    (3)颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的;<br />
                    (4)损害国家荣誉和利益的;<br />
                    (5)宣扬恐怖主义、极端主义的;<br />
                    (6)宣扬民族仇恨、民族歧视，破坏民族团结的;<br />
                    (7)煽动地域歧视、地域仇恨的;<br />
                    (8)破坏国家宗教政策，宣扬邪教和封建迷信的;<br />
                    (9)编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的;<br />
                    (10)散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;<br />
                    (11)危害网络安全 利用网络从事危害国家安全、荣誉和利益的;<br />
                    (12)侮辱或者诽谤他人，侵害他人合法权益的;<br />
                    (13)对他人进行暴力恐吓、威胁，实施人肉搜索的;<br />
                    (14)涉及他人隐私、个人信息或资料的;<br />
                    (15)散布污言秽语，损害社会公序良俗的;<br />
                    (16)侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的;<br />
                    (17)散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息;<br />
                    (18)使用本网站常用语言文字以外的其他语言文字评论的;<br />
                    (19)与所评论的信息毫无关系的;<br />
                    (20)所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的;<br />
                    (21)侵害未成年人合法权益或者损害未成年人身心健康的;<br />
                    (22)未获他人允许，偷拍、偷录他人，侵害他人合法权利的;<br />
                    (23)冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关。<br />
                    (24)伪造标题或以其他方式操控识别资料，使人误认为该内容为我会所传送。<br />
                    (25)将无权传送的内容(例如内部资料、机密资料)进行上载、张贴、发送电子邮件或以其他方式传送。<br />
                    (26)包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形:<br />
                    i.任何暴力和/或自残行为内容;<br />
                    ii.任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容;<br />
                    iii怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容;<br />
                    (27) 其他含有违反法律法规、政策及公序良俗、干扰“商业贸促会数据平台”正常运营或侵犯其他用户或第三方合法权益内容的信息。
                </p>
                <p>5.6. "商业贸促会数据平台"信息内容使用规范</p>
                <p>5.6.1.未经我会书面许可任何用户 第三方均不得自行或授权、允许协助他人对“商业贸促会数据平台”网站及相关服务中信息内容进行如下行为:<br />
                    (1)复制、读取、采用“商业贸促会数据平台”网站及相关服务的信息内容用于包括但不限于宣传、增加阅读量、浏览量等商业用途。<br />
                    (2)擅自编辑、整理、编排商业贸促会数据平台”网站及相关服务的信息内容后在“商业贸促会数据平台”网站及相关服务的源页面以外的渠道进行展示。<br />
                    (3)采用包括但不限于特殊标识、特殊代码等任何形式的识别方法，自行或协助第三人对“商业贸促会数据平台”网站及相关服务的信息内容产生流量、阅读量引导、转移、劫持等不利影响。<br />
                    (4)其他非法获取或使用“商业贸促会数据平台”网站及相关服务的信息内容的行为。
                </p>
                <p>5.6.2.未经我会书面许可,任何用户
                    第三方不得以任何方式(包括但不限于盗链、冗余盗取、非法抓取、模拟下载、深度链接、假冒注册等)直接或间接盗取“商业贸促会数据平台”网站及相关服务的视频、图文等信息内容，或以任何方式(包括但不限于隐藏或者修改域名、平台特有标识用户名等)删除或改变相关信息内容的权利管理电子信息。
                </p>
                <p>5.6.3.经我会书面许可后用户、第三方对“商业贸促会数据平台”网站及相关服务的信息内容的分享、转发等行为,还应符合以下规范
                    (1)对抓取、统计、获得的相关搜索热词、命中率分类、搜索量、点击率、阅读量等相关数据，未经我会事先书面同意，不得将上述数据以任何方式公示、提供泄露给任何第三人;
                    (2)不得对“商业贸促会数据平台”网站及相关服务的源网页进行任何形式的任何改动,包括但不限于“商业贸促会数据平台”网站及相关服务的首页链接、广告系统链接等入口也不得对“商业贸促会数据平台”网站及相关服务的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍;
                    (3)应当采取安全、有效、严密的措施,防止“商业贸促会数据平台”网站及相关服务的信息内容被第三方通过包括但不限于蜘蛛”(spider)程序等任何形式进行非法获取;
                    (4)不得把相关数据内容用于我会书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用。
                    (5)用户向任何第三人分享、转发、复制“商业贸促会数据平台”网站及相关服务信息内容的行为,还应遵守我会为此制定的其他规范和标准如《商业贸促会数据平台社区自律公约》及“商业贸促会数据平台”其他功能的相关协议。
                </p>
                <p>5.6.4.对用户信息的存储和限制我会不对您所发布信息的删除或储存失败承担责任。如果我会有理由认为您的行为违反或可能违反上述约定的，我会可独立进行判断并处理，且在任何时候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。
                </p>
            </div>
            <div class="content">
                <p class="weight">
                    6. 违约处理
                </p>
                <p class="weight">
                    针对您违反本协议或其他服务条款的行为，对涉嫌违反法律法规、涉嫌违法犯罪的行为，我会将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查、向公安机关报案等。对已删除内容我会有权不予恢复。
                </p>
                <p class="weight">
                    6.1.我会尊重并保护用户及他人的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用“商业贸促会数据平台”网站及相关服务时上传的文字、图片、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，我会有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行处理并承担可能因此产生的全部法律责任;如因您的侵权行为导致我会及其关联方、控制我会、继承我会遭受损失的(包括但不限于经济、商誉等损失)，您还应足额赔偿我会及其关联方、控制我会、继承我会遭受的全部损失。
                </p>
                <p class="weight">
                    6.2除非我会收到相反通知，如您在本网站上载或发布的任何内容包含任何第三方提供的信息、内容和服务或涉及个人权益的(包括但不限于姓名权、声音权、肖像权、隐私权等)，我会将视为您已取得相应第三方的充分授权，我会没有任何第三方权益的审查义务，不承担因此带来的任何第三方责任或法律风险。如您进行上述内容在本网站的上载或发布，而导致任何第三方提出索赔要求或衍生的任何损害或损失，您应自行处理并承担可能因此产生的全部法律责任;同时，我会有权基于自主合理判断，依据本协议或相关法律法规对相应内容采取删除、屏蔽、断开链接等必要措施。如因您的侵权行为导致我会及其关联方、控制我会、继承我会遭受损失的(包括但不限于经济、商誉等损失)，您还应足额赔偿我会及其关联方、控制我会、继承我会遭受的全部损失。
                </p>
                <p class="weight">
                    6.3因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担可能因此产生的全部法律责任。因您的违法或违约等行为导致我会及其关联方、控制我会、继承我会向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿我会及其关联方、控制我会、继承我会因此遭受的全部损失。
                </p>
            </div>
            <div class="content">
                <p class="weight">
                    7.免责声明
                </p>
                <p>7.1我会对于任何自本网站而获得的他人的信息、内容或者广告宣传等任何资讯的任何内容(以下统称"信息")，不保证真实、准确、完整、适用或安全性。如果任何用户通过上述"信息"而进行任何行为，须自行甄别真伪和谨慎预防风险，我会不对上述任何信息的使用承担任何直接、间接、附带或衍生的损失和责任。
                </p>
                <p>7.2无论何种原因，我会不对任何非与本网站直接发生的交易和/或行为承担任何直接、间接、附带或衍生的损失和责任。如有涉嫌借款、投融资、理财或其他涉财产的网络信息、账户密码、广告或推广等信息的，请您谨慎对待并自行进行判断，对您因此遭受的利润、商业信誉、资料损失或其他有形或无形损失，我会不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。
                </p>
                <p>7.3您理解并同意，“商业贸促会数据平台”网站及相关服务可能会受多种因素的影响或干扰，我会不保证(包括但不限于):<br />
                    (1)“商业贸促会数据平台”网站及相关服务完全适合用户的使用要求;<br />
                    (2)“商业贸促会数据平台”网站及相关服务不受干扰，及时、安全、可靠或不出现错误;<br />
                    (3)用户经由“商业贸促会数据平台”网站及相关服务取得的任何网站、服务或其他材料符合用户的期望。<br />
                    (4)“商业贸促会数据平台”网站及相关服务中任何错误都将能得到更正。
                </p>
                <p>7.4用户使用经由本网站下载的或取得的任何资料，其风险自行负担;因该等使用导致用户电脑系统损坏或资料流失，用户应负完全责任;</p>
                <p>7.5基于以下原因而造成的利润、商业信誉、资料损失或其他有形或无形损失，我会不承担任何直接、间接、附带、衍生或惩罚性的赔偿:<br />
                    (1)本网站使用或无法使用;<br />
                    (2)经由本网站取得的任何资料或服务;<br />
                    (3)用户资料遭到未授权的使用或修改;<br />
                    (4)其他与本网站相关的事宜。<br />
                </p>
                <p>7.6用户在浏览互联网时自行判断使用本网站的搜索或检索目录。该搜索或检索目录可能会引导用户进入到被认为具有攻击性或不适当的双站，我会没有义务查看检索目录所列网站的内容，因此，对其正确性、合法性、正当性不负任何责任。
                </p>
                <p>7.7对于用户之间的任何交流、交易、分歧、争议或纠纷，用户自行进行负责，我会没有义务进行协调、处理或解决。尽管如此，如果我会基于自主合理判断或根据用户据实投诉、举报，认为您的行为违背了法律、法规或协议条款的规定，我会有暂停或终止向您提供网站服务的权利，并有权对相关内容采取删除、屏蔽、断开链接等合理措施。
                </p>
                <p>7.8您理解并同意，在使用“商业贸促会数据平台”网站及相关服务过程中，可能遇到不可抗力等因素(不可抗力是指不能预见、不能克服并不能避免的客观事件)，包括但不限于政府行为、自然灾害(如洪水、地震、台风等)、网络原因、战争、罢工、骚乱等。出现不可抗力情况时，我会将努力在第一时间及时修复，但因不可抗力造成的暂停、中止、终止服务或造成的任何损失，我会在法律法规允许范围内免于承担责任。
                </p>
                <p>7.9我会依据本协议约定获得处理违法违规内容的权利，该权利不构成我会的义务或承诺，我会不能保证及时发现违法行为或进行相应处理。</p>
                <p>7.10您理解并同意:关于“商业贸促会数据平台”网站及相关服务，我会不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对“商业贸促会数据平台”网站及相关服务的使用行为应自行承担相应风险。
                </p>
                <p>7.11您理解并同意，本协议旨在保障遵守国家法律法规、维护公序良俗，保护用户和他人合法权益，我会在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证我会判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担。
                </p>
                <p>7.12在任何情况下，我会均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用“商业贸促会数据平台”网站及相关服务而遭受的利润损失，承担责任。除法律法规另有明确规定外，我会对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用“商业贸促会数据平台”网站及相关服务期间而支付给我会的费用(如有)。
                </p>
            </div>
            <div class="content">
                <p class="weight">
                    8.知识产权及其他权利
                </p>
                <p>8.1我会在“商业贸促会数据平台”网站及相关服务中提供的内容(包括但不限于网站、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、电子文档等)的知识产权属于我会所有。我会提供“商业贸促会数据平台”及相关服务时所依托的网站的著作权、专利权及其他知识产权均归我会所有。未经我会许可，任何人不得擅自使用(包括但不限于通过任何机器人、“蜘蛛”等程序或设备监视、复制、传播、展示、镜像、上载、下载)“商业贸促会数据平台”网站及相关服务中的内容。
                </p>
                <p>8.2用户不得自行或许可任何第三方对“商业贸促会数据平台”网站及相关服务复制、修改、出售或衍生产品。</p>
                <p>8.3您理解并承诺，您在使用“商业贸促会数据平台”网站及相关服务时发布上传的内容(包括但不限于文字、图片、视频、音频等各种形式的内容及其中包含的音乐、声音、台词、视觉设计等所有组成部分)均由您原创或已获合法授权(且含转授权)。您通过“商业贸促会数据平台”上传、发布所产生内容的知识产权归属您或原始著作权人所有。
                </p>
                <p>8.4我会为“商业贸促会数据平台”开发、运营提供技术支持，并对“商业贸促会数据平台”网站及相关服务的开发和运营等过程中产生的所有数据和信息等享有法律法规允许范围内的全部权利。</p>
                <p>8.5请您在任何情况下都不要私自使用我会的包括但不限于“商业贸促会数据平台”的任何商标、服务标记、商号、域名、网站名称或其他显著品牌特征笁(V下统称为“标道”)
                    未经我会事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。由于您违反本协议使用我会上述商标、标识等给我会或他人造成损失的，由您承担全部法律责任。
                </p>
            </div>
            <div class="content">
                <p class="weight">
                    9.第三方责任
                </p>
                <p>9.1因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行处理并承担可能因此产生的全部法律责任。因您的违法或违约等行为导致我会及其关联方向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿我会及其关联方因此遭受的全部损失。
                </p>
            </div>
            <div class="content">
                <p class="weight">
                    10.服务的变更、中断和终止
                </p>
                <p>10.1您理解并同意，我会提供的“商业贸促会数据平台”网站及相关服务是按照现有技术和条件所能达到的现状提供的。我会会尽最大努力向您提供服务确保服务的连贯性和安全性。您理解，我会不能随时或始终预见和防范法律、技术以及其他风险，包括但不限于不可抗力、网络原因、第三方服务瑕疵、第三方网站等原因可能导致的服务中断、不能正常使用“商业贸促会数据平台”网站及相关服务以及其他的损失和风险。
                </p>
                <p>10.2您理解并同意，我会为了整体服务运营、平台运营安全的需要，有权在任何时候，视具体情况决定服务/功能的设置及其范围修改、中断、中止或终止“商业贸促会数据平台”网站及相关服务(或任何一部分);我会有权基于任何理由，终止用户的账号、密码或使用本服务，或删除、转移用户存储、发布在本服务的内容。商业贸促会数据平台采取上述行为均不需通知，并且对用户和任何第三人不承担任何责任。
                </p>
                <p>10.3您在“商业贸促会数据平台”中的注册帐号仅限于您本人使用，未经我会书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许口他人使用该帐号。如果我会发现或者有合理理由认为使用者并非帐号初始注册人，为保障帐号安全，我会有权立即暂停或终止向该注册帐号提供服务，并有权永久禁用该帐号。
                </p>
                <p>10.4如果我会有理由认为您的行为违反或可能违反上述约定的，我会司独立进行判断并处理，且在任何时候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。</p>
            </div>
            <div class="content">
                <p class="weight">
                    11.帐号注销
                </p>
                <p>目前平台暂不支持帐号注销。</p>
            </div>
            <div class="content">
                <p class="weight">
                    12.未成年人使用条款
                </p>
                <p>12.1若您是未满18周岁的未成年人，您应在您的监护人监护、指导下并获得监护人同意的情况下,认真阅读并同意本协议后，方可使用“商业贸促会数据平台"网站及相关服务。在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，养成良好上网习惯。<br />若您未取得监护人的同意监护人可以通过平台公示渠道通知平台处理相关帐号,平台有权对相关帐号的功能、使用进行限制，包括但不限于浏览、发布信息、互动交流等功能。
                </p>
                <p>12.2未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容,则您及您的监护人应依照法律规定承担因此而可能导致的全部法律责任。</p>
                <p>12.3为更好地保护未成年人隐私权益,我会特别提醒您慎重发布包含未成年人素材的内容,一经发布，即视为您已获得权利人同意在“商业贸促会数据平台"网站及相关服务展示未成年人的肖像、声音等信息，且允许我会依据本协议使用、处理该等与未成年人相关的内容。
                </p>
                <p>12.4青少年用户必须遵守《全国青少年网络文明公约》<br />
                    (1) 要善于网上学习，不浏览不良信息;(2)要诚实友好交流，不侮辱欺诈他人:(3)要增强自护意识，不随意约会网友:(4)要维护网络安全，不破坏网络秩序:(5)要有益身心健康，不沉溺虚拟时空。
                </p>
                <p>12.5监护人特别提示</p>
                <p>12.5.1如您的被监护人使用“商业贸促会数据平台”网站及相关服务的您作为监护人应指导并监督被监护人的注册和使用行为如您的被监护人申请注册商业贸促会数据平台帐号我会将有权认为其已取得您的同意。</p>
            </div>
            <div class="content">
                <p class="weight">
                    13.通知
                </p>
                <p>我会向您发出的通知，采用电子邮件、短信或电话的形式。本协议条款的修改或其他事项变更时，我会将会以上述某一形式进行通知。如您不愿意接收“商业贸促会数据平台”推送通知服务的，请联系我会。</p>
            </div>
            <div class="content">
                <p class="weight">
                    14.联系方式
                </p>
                <p>
                    官方网站http://www.ccpitcsc.org/
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import navBar from "@/components/navBar.vue";
export default {
    components: {
        navBar,
    },
    data() {
        return {

        };
    },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.main {
    margin-top: 50px;
    text-align: left;
    font-family: "SimSun", serif;
    padding: 0 15px 50px;
    line-height: 1.5;
    letter-spacing: 1px;

    .weight {
        font-weight: bold;
    }

    .title {
        text-align: center;
        font-size: 24px;
        margin-bottom: 10px;
    }

    .time {
        text-align: right;
        font-size: 12px;

        .line {
            border-bottom: 1px solid #000;
            padding-left: 20px;
            padding-right: 3px;
        }
    }

    .content {
        font-size: 14px;
        margin-top: 10px;

        p {
            margin-top: 5px;
        }
    }
}
</style>